import axios from "axios";

export default axios.create({
  baseURL: "https://server-api-jcv9.onrender.com",
});